import Cookies from "universal-cookie";
const jose = require("jose");

class Api {
  constructor() {
    this.url = process.env.REACT_APP_API_URL || "";
    this.defaultFetchOptions = {};

    if (process.env.NODE_ENV === "development") {
      this.defaultFetchOptions.credentials = "include";
    }
  }

  getOwners() {
    const claims = getClaims();

    let orgs = [];
    if (claims.orgs && claims.orgs.length) {
      orgs = claims.orgs.split(",");
    }

    return orgs;
  }

  async getRunners() {
    const response = await fetch(`${this.url}/api/runners`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    let runners = await response.json();
    if (runners) {
      runners.sort((a, b) => (a.vms > b.vms ? -1 : 1));
    }

    return runners;
  }

  async getJobQueue() {
    const claims = getClaims();

    // console.log(claims,claims.orgs)
    let qs = "?owners=" + claims.orgs;
    const response = await fetch(`${this.url}/api/job-queue` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    let jobs = await response.json();
    jobs.sort((a, b) => {
      let dateDiff = new Date(a.startedAt) < new Date(b.startedAt) ? -1 : 1;
      if (a.status == "in_progress" && b.status != "in_progress") {
        return -1;
      } else if (a.status != "in_progress" && b.status == "in_progress") {
        return 1;
      }

      return dateDiff;
    });

    return jobs;
  }

  async getRepoStats(period, includeToday = false) {
    const claims = getClaims();

    let qs = `?owners=${claims.orgs}&period=${period}&include_today=${includeToday}`;
    const response = await fetch(`${this.url}/api/repo-stats` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  async getJobIncreases(owner, startDate) {
    const startDateShort = new Date(startDate).toISOString().split("T")[0];
    let qs = `?owner=${owner}&startDate=${startDateShort}`;
    const response = await fetch(`${this.url}/api/job-increases` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  // stat.owner,
  // stat.repo,
  // stat.workflow_name,
  // stat.job_name,
  // stat.current_year,
  // stat.current_week
  async getDailyMaximumsByJob(owner, repo, workflowName, jobName, year, week) {
    let qs = new URLSearchParams({
      owner: owner,
      repo: repo,
      workflowName: workflowName,
      jobName: jobName,
      year: year,
      week: week,
    }).toString();

    const response = await fetch(`${this.url}/api/job-daily-maximums?${qs}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  async getUserStats(period, includeToday = false) {
    const claims = getClaims();

    let qs = `?owners=${claims.orgs}&period=${period}&include_today=${includeToday}`;
    const response = await fetch(`${this.url}/api/user-stats` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  async getDailyStats() {
    const claims = getClaims();

    // console.log(claims,claims.orgs)
    let qs = "?owners=" + claims.orgs;
    const response = await fetch(`${this.url}/api/daily-stats` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    let stats = await response.json();
    stats.sort((a, b) => (a.totalJobs > b.totalJobs ? -1 : 1));
    return stats;
  }

  async getBuildReport(owner, period) {
    let qs = `?owner=${owner}&period=${period}`;
    const response = await fetch(`${this.url}/api/build-report` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      let report = await response.json();
      return report;
    }

    return {};
  }

  async getDebugSessions() {
    const response = await fetch(`${this.url}/api/debug-sessions`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      let sessions = await response.json();
      return sessions;
    }

    return [];
  }

  async getEvents() {
    const claims = getClaims();

    let qs = `?owners=${claims.orgs}`;
    const response = await fetch(`${this.url}/api/events` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  async getSnapshots(owner, limit) {
    let qs = `?owners=${owner}&limit=${limit}`;
    const response = await fetch(`${this.url}/api/snapshots` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }

  async getSnapshot(jobID, owner) {
    let qs = `?owner=${owner}&job=${jobID}`;
    const response = await fetch(`${this.url}/api/snapshot` + qs, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      ...this.defaultFetchOptions,
    });

    if (response.status === 401) {
      // Reload to redirect to login page when the auth token is missing/expired.
      window.location.reload();
    }

    if (response.ok) {
      return await response.json();
    }

    return [];
  }
}

function getClaims() {
  let cookie = new Cookies();
  let token = cookie.get("actuated_dashboard");
  if (!token) {
    // Reload to redirect to login page when the auth token is missing/expired.
    window.location.reload();
  }

  const claims = jose.decodeJwt(token);

  return claims;
}

export default Api;
